const missionSlug = () => {
    return window.location.hostname.split('.')[0];
};

export default missionSlug;
